// Just like table quiz, this modal blocks out a table from being shown
// until a user chooses an option in the form.
import $ from 'jquery';
import './style.scss';
import filterHelper from '../filters/helper';
const comparisonCalculatorSelector = '.js-comparison-calculator';
const comparisonTableSelector = '.js-calculator-table';
const closeModalClassName = 'table-modal--closed';

function closeModal(modal, modalForm) {
  modal.classList.add(closeModalClassName);
  $(modalForm).addClass('hide');
}

function reopenModal({ target: modal }) {
  const $modalForm = $(modal).find('form');
  $(modal).removeClass(closeModalClassName);
  $modalForm.removeClass('hide');
  $modalForm[0].reset();
}

/**
 * Option to redraw table (body_only or full_table)
 * @param modalForm
 * @param modal
 * @param category - table category (AJAX category parameter)
 * @param fieldset - table template (AJAX fieldset parameter)
 * @param filters - table filter (AJAX filters parameter)
 */
function redrawTable(modalForm, modal, { category, fieldset }, filters) {
  const $parent = $(modalForm).closest(comparisonCalculatorSelector);
  const $table = $parent.find(comparisonTableSelector);
  // If previous table has a different table template, redraw full table
  const shouldRedrawFullTable = $parent.data('fieldset') !== fieldset;
  $parent.attr('data-category', category);
  $parent.attr('data-fieldset', fieldset);

  $table.trigger('onLoading');

  const getParams = {
    action: 'redraw_table_ajax',
    template: 'comparison',
    site: $parent.data('site'),
    fieldset,
    category,
  };

  const $formAboveTable = $parent.find('.js-form-widget--filter');
  if (filters) {
    filterHelper.updateFormAboveTable($formAboveTable, filters);
    getParams.filters = filters;
  }

  if (shouldRedrawFullTable) {
    getParams.full_table = true;
  }

  $.get(`${window.location.origin}/wordpress/wp-admin/admin-ajax.php`, getParams)
    .then((result) => {
      const doWeHaveResult = result && result.html;
      closeModal(modal, modalForm);
      if (doWeHaveResult) {
        if (shouldRedrawFullTable) {
          $parent.replaceWith(result.html);
          $(document).trigger('full-table-redraw');
        } else {
          $parent.find(`${comparisonTableSelector} tbody`).html(result.html);
          window.finder.calculators.submitData($parent);
        }
      } else {
        $formAboveTable.find('.js-table-widget-message').show();
        $table.hide();
      }
    })
    .always(results => $table.trigger('onLoaded', results));
}

function tableModal(selector) {
  const modals = document.querySelectorAll(selector);

  if (modals.length) {
    $(modals).each((i, modal) => {
      const form = $(modal).find('.js-table-modal__form');
      const trackingCategory = $(modal).data('track-category');
      const processOption = (event, filters = false) => {
        event.preventDefault();
        const data = event.target.dataset;
        redrawTable(form, modal, data, filters);
      };
      const areFieldsValid = (requiredFields) => {
        const doWeHaveRequiredFields = requiredFields.length;
        let valid = true;
        if (doWeHaveRequiredFields) {
          requiredFields.each((index, field) => {
            const $field = $(field);
            const $parent = $field.parent();
            const value = $field.val();
            if (value !== '' || (!isNaN(value) && value === 0)) {
              valid = true;
              $parent.removeClass('is-invalid');
            } else {
              valid = false;
              $parent.addClass('is-invalid');
            }
          });
        }

        return valid;
      };

      form.find('input.js-table-modal__option').on('change', processOption);

      form.find('a.js-table-modal__option').on('click', processOption);

      form.on('submit', (event) => {
        event.preventDefault();
        const requiredFields = $(form).find('[is-required]');
        if (areFieldsValid(requiredFields)) {
          const filters = filterHelper.getFormFilters($(form));
          processOption(event, filters);

          const formHasTrackAction = form[0].dataset.trackAction;
          if (formHasTrackAction) {
            const trackingValues = filters.map(filter => filter.value).join(', ');
            $.trackEvent(trackingCategory, formHasTrackAction, trackingValues);
          }
        }
      });

      // Tracking for modal actions
      form.find('[data-track-action]').on('click', ({ target }) => $.trackEvent(
        trackingCategory,
        target.dataset.trackAction));

      // Event listener to re-open modal on filter form reset
      $(modal).on('reopenTableModal', reopenModal);
    });
  }
}

export default tableModal;
